import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  fetchPolicies: `${NAMESPACE}_FETCH_POLICIES`,
  fetchPoliciesSuccess: `${NAMESPACE}_FETCH_POLICIES_SUCCESS`,
};

export const actionCreators = {
  fetchPolicies: payload => ({ type: actions.fetchPolicies, payload }),
  fetchPoliciesSuccess: payload => ({ type: actions.fetchPoliciesSuccess, payload }),
};

export default {
  actions,
  actionCreators,
};
